/** @warning should be used only within in the feature-flag package */
const windowFF = window as unknown as {
  ff: { [key: string]: unknown };
};

const storageKey = "config-cat/feature-flag-config";

export const hasStoredFlags = () => !!localStorage.getItem(storageKey);

export const getGlobalFeatureFlags = () => windowFF.ff;

const isCompatibleFF = (x: unknown): x is { [key: string]: unknown } =>
  !!x && typeof x === "object" && Object.keys(x).length > 0;

const getStoredConfig = () => {
  try {
    const storedFlagString = localStorage.getItem(storageKey);
    if (!storedFlagString) return null;
    const storedFlagParsed: unknown = JSON.parse(storedFlagString);
    if (!isCompatibleFF(storedFlagParsed)) {
      throw new TypeError(`${storedFlagParsed} is not a feature flag object`);
    }

    return storedFlagParsed;
  } catch (error) {
    console.warn("Failed to read stored response:", error);
  }
  return null;
};

export const setGlobalConfigFromStorage = () => {
  const storedConfig = getStoredConfig();
  if (storedConfig) {
    windowFF.ff = storedConfig;
  }
};

export const updateGlobalConfig = (
  config: { [key: string]: unknown },
  useStorage = true
) => {
  if (useStorage) {
    localStorage.setItem(storageKey, JSON.stringify(config));
    const storedConfig = getStoredConfig();
    if (storedConfig) {
      windowFF.ff = storedConfig;
      return;
    }
  }
  windowFF.ff = config;
};
